module.exports = __webpack_public_path__ + "static/media/goteborgvapen.f5ac213b.png";